// 货品详情图集
import React from 'react'
import { Image as AntdImage } from 'antd-mobile'
import styles from './ProductGraphic.module.less'

interface Props {
  visible: boolean
  mediaList: string[]
  detailImageClick?: (index: number, url: string) => void
}

const ProductGraphic: React.FC<Props> = ({ visible = false, mediaList = [], detailImageClick }) => {
  return (
    visible && (
      <div className={styles['graphic-wrap']}>
        {mediaList.map((item, index) => (
          <AntdImage
            key={index}
            fit="cover"
            src={item}
            lazy={true}
            onClick={() => detailImageClick(index, item)}
          />
        ))}
      </div>
    )
  )
}

export default ProductGraphic
